import cls from "./AdminOperationalWarnings.module.scss";

export default function AdminOperationalWarnings({ warningsPayload }) {
  const warnings = warningsPayload?.warnings || [];

  return (
    <section className={cls.panel}>
      <p className={cls.kicker}>SYSTEM HEALTH</p>
      <h3 className={cls.title}>Operational Warnings</h3>

      {!warnings.length ? (
        <p className={cls.empty}>No active warnings.</p>
      ) : null}

      <ul className={cls.list}>
        {warnings.map((warning) => (
          <li key={warning.code} className={cls.item}>
            <strong className={cls.severity}>
              [{warning.severity || "info"}]
            </strong>
            <span>{warning.message}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
